export function nlToBr(string: string | null): string {
    if (!string) return '';
    return string.replace(/\n/g, '<br/>');
}